<template>
  <div class="card-box">
    <div class="card-box-tt">
      <div v-if="title">{{title}}</div>
       <slot name="tt_l"><div></div> </slot>
      <slot name="tt_r"><div></div></slot>
    </div>
    <div class="card-box-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardBox",
  props: {
    title: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/css">
.card-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 0px -2px 7px 0px rgba(164, 161, 161, 0.23);
  position: relative;
}
.card-box .card-box-tt {
  line-height: 38px;
  height: 38px;
  text-align: left;
  padding: 0 20px;
  font-size: 14px;
  color: #999999;
  background: rgba(251, 251, 251, 1);
  border-radius: 5px 5px 0px 0px;
  display: flex;
  /* flex-direction: row-reverse; */
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  

}
.card-box .card-box-box {
  position: relative;
  height: calc(100% - 38px);
  overflow: auto;
}
.card-box-box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.card-box-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.card-box-box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

</style>
<style>
.card-box .card-box-tt .butn{
  height: 26px;
  background: rgba(49, 202, 132, 1);
  border: none;
  padding: 0;
  border-radius: 3px;
  line-height: 26px;
  color: #fff;
  font-size: 14px;
  color: #ffffff;
  padding: 0 10px;
}
.card-box .card-box-tt .butn_text{
color: #009854;
font-size: 14px;
text-decoration:underline;
}
</style>